import {Route, Routes} from 'react-router-dom' 
import {Login} from './components/Login'
import {ForgotPassword} from './components/ForgotPassword'
import {AuthLayout} from './AuthLayout'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} /> 
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
